import { render, staticRenderFns } from "./cardTemplateVip101.vue?vue&type=template&id=244ca650&scoped=true&"
import script from "./cardTemplateVip101.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip101.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip101.vue?vue&type=style&index=0&id=244ca650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ca650",
  null
  
)

export default component.exports